const funções = {
    formatarDataHora(valor) {
        if (valor) {
            if (valor) {
                return valor.slice(0, 10)
            } else {
                return ''
            }
        }
    },

    somarHP(dados) {
        let somaPendentes = 0;
        let somaEmAndamento = 0;
        let somaConcluidos = 0;

        if (dados.backlogs) {
            dados.backlogs.forEach(backlog => {
                if (backlog.status === 'Pendente') {
                    if (backlog.HP) {
                        somaPendentes += parseInt(backlog.HP);
                    }
                }
                if (backlog.status === 'Em andamento' || backlog.status === 'Em andamento 25%' || backlog.status === 'Em andamento 50%' || backlog.status === 'Em andamento 75%') {
                    if (backlog.HP) {
                        somaEmAndamento += parseInt(backlog.HP);
                    }
                }
                if (backlog.status === 'Concluído') {
                    if (backlog.HP) {
                        somaConcluidos += parseInt(backlog.HP);
                    }
                }
            });
        }
        let lista = [somaPendentes, somaEmAndamento, somaConcluidos]
        return lista;
    },

    somarHP2(dados) {
        let somaPendentes = 0;
        let somaEmAndamento = 0;
        let somaConcluidos = 0;

        if (dados.tarefas) {
            dados.tarefas.forEach(backlog => {
                if (backlog.status === 'Pendente') {
                    if (backlog.HP) {
                        somaPendentes += parseInt(backlog.HP);
                    }
                }
                if (backlog.status === 'Em andamento' || backlog.status === 'Em andamento 25%' || backlog.status === 'Em andamento 50%' || backlog.status === 'Em andamento 75%') {
                    if (backlog.HP) {
                        somaEmAndamento += parseInt(backlog.HP);
                    }
                }
                if (backlog.status === 'Concluído') {
                    if (backlog.HP) {
                        somaConcluidos += parseInt(backlog.HP);
                    }
                }
            });
        }
        let lista = [somaPendentes, somaEmAndamento, somaConcluidos]
        return lista;
    },

    nomeEsobrenome(nome) {
        if (!nome || typeof nome !== 'string') {
            return nome ?? '';
        }
        const partes = nome.trim().split(/\s+/).filter(Boolean);
        if (partes.length <= 1) {
            return partes[0] ?? nome.trim();
        }
        const primeiroNome = partes[0];
        const segundoNome = partes[1];
        if (partes.length >= 3 && segundoNome.length > 3 && segundoNome !== 'Paula') {
            return `${primeiroNome} ${partes[partes.length - 1]}`;
        }
        if (segundoNome.length <= 3 || segundoNome === 'Paula') {
            return `${primeiroNome} ${segundoNome} ${partes[2] || ''}`.trim();
        }
        return `${primeiroNome} ${segundoNome}`;
        // return nome;
    },

    abreviarMes(dataString, mandarAno) {
        if (dataString == null) {
            return null
        }
        const partes = dataString.split('-');

        if (partes.length !== 3) {
            if (process.env.NODE_ENV !== 'production') console.error('Formato de data inválido. Use o formato AAAA-MM-DD');
            return null;
        }

        const ano = partes[0].slice(2);
        const mesNumero = parseInt(partes[1], 10);
        const dia = partes[2];

        const mesesAbreviados = [
            'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
            'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
        ];

        if (mesNumero < 1 || mesNumero > 12) {
            return 'Número do mês inválido.'
        }

        const mesAbreviado = mesesAbreviados[mesNumero - 1];

        if (mandarAno) {
            return `${dia}/${mesAbreviado}./${ano}`;
        } else {
            return `${dia}/${mesAbreviado}.`;
        }
    },
}
export default funções;